module.exports = __webpack_public_path__ + "static/media/buildingConstruction41.2f5dd35a.jpg";